import { inject, Injectable } from '@angular/core';
import { environment } from '../environment/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RegistroPagamentiDto, RicercaRegistroPagamentiDto, Sollecito } from '../model/print-data';
import { PagedDataset } from '../model/filters-data';

@Injectable({
  providedIn: 'root'
})
export class SollecitiService {

  private _http = inject(HttpClient);
  private solleciti_api: string = `${environment.baseUrl}/solleciti`;
  private registro_api: string = `${environment.baseUrl}/registro/pagamenti`;

  getSollecitiLista(): Observable<Sollecito[]>{
    return this._http.get<Sollecito[]>(`${this.solleciti_api}/lista`);
  }

  getSollecitoCorrente(): Observable<Sollecito>{
    return this._http.get<Sollecito>(`${this.solleciti_api}/get-corrente`);
  }

  updateSollecitoCorrente(sollecito: Sollecito): Observable<void>{
    return this._http.post<void>(`${this.solleciti_api}/modifica-sollecito-corrente`, sollecito)
  }

  ricercaRegistroPagamenti(data: RicercaRegistroPagamentiDto): Observable<PagedDataset<RegistroPagamentiDto>>{
    return this._http.post<PagedDataset<RegistroPagamentiDto>>(this.registro_api, data);
  }

}
